/**
 * Tiny preview of a normalized shape (0-100, 0 = bottom) — "what we'll actually
 * match against" for both the image-upload digitizer and the ticker+lookback
 * picker, so the user sees the resampled series before spending a query on it.
 * Stroke is `currentColor` so the caller controls the color from CSS.
 */
export default function ShapeSparkline({shape}: {shape: number[]}) {
  if (shape.length < 2) return null;
  const w = 300;
  const h = 80;
  const points = shape
    .map((v, i) => `${(i / (shape.length - 1)) * w},${h - (v / 100) * h}`)
    .join(" ");
  return (
    <svg viewBox={`0 0 ${w} ${h}`} className="shape-upload-sparkline" preserveAspectRatio="none">
      <polyline
        points={points}
        fill="none"
        stroke="currentColor"
        // non-scaling-stroke keeps this 1 CSS px regardless of how far
        // preserveAspectRatio="none" stretches the 300-unit viewBox to fill its
        // container — without it the stroke scales with the box and a dense shape
        // (an image digitized at ~1000 points) renders as a solid block of color.
        vectorEffect="non-scaling-stroke"
        strokeWidth={1}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
